import { LabMDM } from "../masterdata/models/lab";
import { ReactionPlateQuadrant } from "./reaction-plate-quadrant";
import { OrderDetails } from './order-details';

/**    
  * @author Naveen 
  * @description ReactionPlacementRequest model 
  */
export class ReactionPlacementRequest{

lab:LabMDM;

reactionPlateId:string;

reactionPlateQuadrants:Array<ReactionPlateQuadrant>;

reactionSetIds:Array<string>;

orderHistory:Array<OrderDetails>

}